import { z } from "zod";

export const ReviewHistoryFilters = ["LastReview", "PastNinetyDays", "LastYear", "LastTwoYears"] as const;
const ReviewHistoryFilterSchema = z.enum(ReviewHistoryFilters);
export type ReviewHistoryFilter = z.infer<typeof ReviewHistoryFilterSchema>;

export const PeriodSelectionSchema = z.object({
    reviewCycleIds: z.array(z.string()).optional(),
    reviewHistoryFilter: ReviewHistoryFilterSchema.optional(),
    from: z.string().optional(),
    to: z.string().optional()
});
export type PeriodSelection = z.infer<typeof PeriodSelectionSchema>;

export function toPeriodKey(period: PeriodSelection): string {
    if (period.reviewCycleIds?.length) {
        return `cycles:${period.reviewCycleIds.toSorted().join(",")}`;
    }

    if (period.reviewHistoryFilter) {
        return `preset:${period.reviewHistoryFilter}`;
    }

    if (period.from || period.to) {
        return `range:${period.from ?? ""}..${period.to ?? ""}`;
    }

    return "all";
}
